/* Language layer: German for visitors from DE/AT/CH (or German browser), manual DE|EN toggle, choice remembered. */
(function(){
  var d=document.documentElement,DA=['DE','AT','CH','LI'],GEO='https://hourglass-aubergine.vercel.app/api/geo',pref=null,geo=null,now=Date.now();
  function g(k){try{return localStorage.getItem(k)}catch(e){return null}}
  function s(k,v){try{localStorage.setItem(k,v)}catch(e){}}
  var m=location.search.match(/[?&]lang=(de|en)\b/);if(m)s('hg_lang',m[1]);
  pref=g('hg_lang');
  var gv=(g('hg_geo')||'').split('|');if(gv[0]&&now-(+gv[1]||0)<864e5)geo=gv[0];
  function tz(){try{return /^Europe\/(Berlin|Vienna|Zurich|Busingen|Vaduz)$/.test(Intl.DateTimeFormat().resolvedOptions().timeZone)}catch(e){return false}}
  var de=pref?pref==='de':(geo?DA.indexOf(geo)>-1:(tz()||/^de\b/i.test(navigator.language||'')));
  window.HG_LANG=de?'de':'en';
  if(de){
    d.classList.add('hg-de','hg-dep');d.lang='de';
    setTimeout(function(){d.classList.remove('hg-dep')},3000);
    var U=window.HG_DEU||[];U.forEach(function(u){var x=document.createElement('script');x.src=u;x.async=false;document.head.appendChild(x)});
  }
  if(!geo&&!pref){
    try{fetch(GEO,{cache:'no-store'}).then(function(r){return r.json()}).then(function(j){
      if(!j||!j.c)return;s('hg_geo',j.c+'|'+Date.now());
      if(!g('hg_lang')&&(DA.indexOf(j.c)>-1)!==de)location.reload();
    }).catch(function(){})}catch(e){}
  }
  var st=document.createElement('style');
  st.textContent='html.hg-dep body{visibility:hidden}[data-hgx]{display:none!important}.hglang{display:inline-flex;gap:8px;align-items:center;font:400 12px/1 Jost,sans-serif;letter-spacing:.06em;margin:14px 0 4px}.hglang a{color:inherit;text-decoration:none;opacity:.6;cursor:pointer}.hglang a.on{opacity:1;font-weight:600;text-decoration:underline;text-underline-offset:3px}.hglang.fx{position:fixed;left:12px;bottom:12px;z-index:50;background:#fff;color:#3A1B33;padding:8px 12px;border-radius:20px;box-shadow:0 1px 8px rgba(0,0,0,.15)}';
  document.head.appendChild(st);
  function toggle(){
    if(document.querySelector('.hglang'))return;
    if(!(de||(geo&&DA.indexOf(geo)>-1)||tz()||/^de(-|$)/i.test(navigator.language||'')))return;
    var w=document.createElement('div');w.className='hglang';w.setAttribute('translate','no');
    w.innerHTML='<a data-l="de"'+(de?' class="on"':'')+'>Deutsch</a><span>|</span><a data-l="en"'+(de?'':' class="on"')+'>English</a>';
    w.addEventListener('click',function(e){var l=e.target.getAttribute&&e.target.getAttribute('data-l');if(!l)return;s('hg_lang',l);location.reload()});
    var f=document.querySelector('footer');if(f){f.appendChild(w)}else{w.className+=' fx';document.body.appendChild(w)}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',toggle);else toggle();
})();
